import cx from 'classnames';
import React from 'react';
import styles from '../card.module.scss';
export const CardHeader = ({ children, showDivider = false, className, }) => {
    const dividerClass = cx({ [styles.divider]: showDivider });
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: cx(styles.cardSectionWrapper, className) }, children),
        showDivider && React.createElement("div", { className: dividerClass })));
};
//# sourceMappingURL=card-header.js.map